export default {
	about_data(state) {
		return state.about_data
	},
}
